import { NetworkError, toApiError } from './errors';

interface FetchResult<T> {
  data?: T;
  error?: unknown;
  response: Response;
}

/**
 * Turns an openapi-fetch result into data-or-throw. Every service goes through this, so
 * screens only ever see typed data, ApiError (problem+json) or NetworkError.
 */
export async function unwrap<T>(call: Promise<FetchResult<T>>): Promise<T> {
  let result: FetchResult<T>;
  try {
    result = await call;
  } catch (e) {
    throw new NetworkError(e);
  }
  if (result.error !== undefined || !result.response.ok)
    throw toApiError(result.error, result.response);
  return result.data as T;
}

/** For 204 responses. */
export async function unwrapEmpty(call: Promise<FetchResult<unknown>>): Promise<void> {
  await unwrap(call);
}

/** ETag for optimistic concurrency (ADR-0009). */
export const ifMatch = (version: number) => ({ 'If-Match': `"v${version}"` });
